import React from 'react';
import PropTypes from 'prop-types';

import {
  Segment,
  Header,
  Item,
  Container,
  Label,
  Icon,
  Message
} from 'semantic-ui-react';

import modes from './constants/modes';

const UploaderAssetSummary = ({
  processedFiles,
  selectedTagOptions,
  numberOfSelectedFiles,
  numberOfFilesInWorker
}) => {
  const selectedTags = Object.keys(selectedTagOptions)
    .map((key) => selectedTagOptions[key])
    .flat()
    .map((option) => {
      const { text } = option;

      return text;
    });

  const uploadedFiles = processedFiles.filter(
    (file) => file.status === modes.UPLOADER_PANEL.COMPLETED
  );
  const failedFiles = processedFiles.filter((file) => file.status === 'ERROR');

  return (
    <div>
      {numberOfSelectedFiles === processedFiles.length &&
        numberOfFilesInWorker > 0 && (
          <Message icon warning style={{ left: 0, right: 0, top: 0 }} fluid>
            <Icon name="circle notched" loading />
            <Message.Content>
              <Message.Header>Upload in progress</Message.Header>
              {`${numberOfFilesInWorker} file(s) are waiting to finish uploading - as long as you keep the Asset Gallery open, you can close the upload panel.`}
            </Message.Content>
          </Message>
        )}

      <Segment.Group>
        <Segment
          style={{
            backgroundColor: '#fcfff5'
          }}
        >
          {/* uploaded assets */}
          <Header size="medium" style={{ color: '#2c662d' }}>
            Uploaded Assets
          </Header>
          {uploadedFiles.length > 0 ? (
            uploadedFiles.map((uploadedFile) => {
              const { file } = uploadedFile;
              const { name } = file;

              return (
                <Item key={`uploaded-file-${name}`}>
                  <Item.Header
                    style={{
                      color: '#2c662d',
                      opacity: 0.9,
                      overflowWrap: 'break-word'
                    }}
                  >
                    {name}
                  </Item.Header>
                </Item>
              );
            })
          ) : (
            <Header icon textAlign="center">
              <Icon name="file image outline" />
              <Header.Content>No results</Header.Content>
            </Header>
          )}
        </Segment>

        {failedFiles.length > 0 && (
          <Segment
            style={{
              backgroundColor: '#fff6f6'
            }}
          >
            {/* Failed assets */}
            <Header size="medium" style={{ color: '#9f3a38' }}>
              Failed Assets
            </Header>

            {failedFiles.length > 0 ? (
              failedFiles.map((failedFile) => {
                const { file } = failedFile;
                const { name } = file;
                return (
                  <Item key={`failed-file-${name}`}>
                    <Item.Header
                      style={{
                        color: '#9f3a38',
                        opacity: 0.9,
                        overflowWrap: 'break-word'
                      }}
                    >
                      {name}
                    </Item.Header>
                  </Item>
                );
              })
            ) : (
              <Header icon textAlign="center">
                <Icon name="file image outline" />
                <Header.Content>No results</Header.Content>
              </Header>
            )}
          </Segment>
        )}

        <Segment>
          {/* Tags summary */}
          <Header size="medium">Tags</Header>

          <Container>
            {selectedTags.map((tag) => (
              <Label
                key={`selected-tag-${tag}`}
                style={{ marginBottom: '0.5em' }}
                size="small"
              >
                {tag}
              </Label>
            ))}
          </Container>
        </Segment>
      </Segment.Group>
    </div>
  );
};

UploaderAssetSummary.defaultProps = {
  selectedTagOptions: {},
  tagOptions: {}
};

UploaderAssetSummary.propTypes = {
  processedFiles: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,

      status: PropTypes.string.isRequired,
      file: PropTypes.shape({
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired
      })
    })
  ).isRequired,
  selectedTagOptions: PropTypes.object,
  tagOptions: PropTypes.object
};

export default UploaderAssetSummary;



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/UploaderAssetSummary.jsx